export default __webpack_public_path__ + "static/media/pickaclass.8fbb20ca.png";